import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorSaveQueryService, SaveQuery} from '@tj/tj-dmp-lib-api';
import {SelectItem} from 'primeng/api';

@Component({
    selector: 'dmp-select-save-query',
    templateUrl: './select-save-query.component.html',
    styleUrls: ['./select-save-query.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectSaveQueryComponent
        }
    ],
    standalone: false
})
export class SelectSaveQueryComponent implements OnChanges, ControlValueAccessor {

    @Input() value: string;
    @Input() disabled = false;
    @Input() codeDataView: string = null;
    @Input() codeTenant: string;
    @Input() codePartner: string;
    /** false : aucun preset présélectionné, la liste s'ouvre vide. */
    @Input() autoSelectFirst = true;
    @Input() placeholder: string;
    /** Champ de recherche dans la liste des presets. */
    @Input() filter = false;
    @Output() change = new EventEmitter<string>();

    list: SelectItem[] = [];
    touched = false;
    private data: SaveQuery[];

  constructor(
      private configuratorSaveQueryService: ConfiguratorSaveQueryService) { }


    onChange = (value) => { /**/ };
    onTouched = () => { /**/ };

    ngOnChanges(changes: SimpleChanges): void {
        this.updateValue();
    }

    writeValue(codePartner: any): void {
        this.value = codePartner;
        this.updateValue();
    }
    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    private updateValue() {
        this.list = [];
        if (this.codeTenant && this.codeDataView) {
            this.configuratorSaveQueryService.getAllSaveQuerysByDatastoreUsingGET(this.codeTenant, this.codePartner, this.codeDataView)
                .subscribe((res) => {
                    this.data = res;
                        this.list = res.map(i => ({label: i.name, value: i.id} as SelectItem));
                        if (this.autoSelectFirst && this.value == null && this.list && this.list.length > 0) {
                            this.value = this.list[0].value;
                            this.saveQueryChange();
                        }
                    }
                );
        }
    }

    public getCurrentSaveQuery() {
        if (this.value && this.data) {
            return this.data.filter(d => this.value === d.id)[0];
        } else {
            return null;
        }
    }

    saveQueryChange() {
        if (this.value != null && !this.disabled) {
            this.onChange(this.value);
            this.markAsTouched();
            this.change.emit(this.value);
        }
    }
}
